import { MotorVehicleSearchProductItem } from "Hooks/Api/apiPrice";
import { useApiPaymentSummary } from "Hooks/ApiHooks/useApiPayment";
import React from "react";
import { PaymentSummarySection } from "../PaymentSummaryCard/PaymentSummarySection";
import InlineSpinner from "../Spinner/InlineSpinner";
import { MotorVehicleSearchDescription } from "./MotorVehicleSearchDescriptionSection";
import { MotorVehicleSearchRequest, MotorVehicleSearchTypeOptions } from "./MotorVehicleSearchTypes";

type Props = {
	businessEntityName: string;
	organisationId: string;
	mvsData: MotorVehicleSearchRequest;
	productItem: MotorVehicleSearchProductItem;
}

export const MotorVehicleSearchPaymentSummaryCard: React.FunctionComponent<Props> = ({ businessEntityName, organisationId, mvsData, productItem }) => {
	const response = useApiPaymentSummary({
		organisationId,
		services: [{
			id: productItem.id,
			serviceType: "MotorVehicleSearch",
		}]
	});

	const lookupValues = (() => {
		let values: Record<string, string> = {};
		switch (mvsData.searchBy) {
			case "Vin":
				values = {
					"Serial number": mvsData.value || "",
				};
				break;
			case "RegistrationNumber":
				values = {
					"Registration number": mvsData.value || "",
					"State": mvsData.state || "",
				};
				break;
			default:
				break;
		}
		return values;
	})();

	if (response.type === "loading") {
		return (
			<div className="stack center vertical">
				<InlineSpinner />
				<p>Verifying payment method...</p>
			</div>
		)
	}

	if (response.type === "error" || !response.data) {
		return (
			<div className="alert-box error">
				Failed to retrieve the payment summary. Please try again later.
			</div>
		)
	}

	return (
		<PaymentSummarySection>
			<MotorVehicleSearchDescription
				searchType={productItem.name}
				billTo={businessEntityName}
				searchBy={MotorVehicleSearchTypeOptions[mvsData.searchBy]}
				lookupValues={lookupValues}
			/>
			<PaymentSummarySection.OrderItemAndCalculation
				paymentSummary={{
					items: response.data.items,
					totalAmountIncGst: response.data.totalAmountIncGst,
					totalAmountExcGst: response.data.totalAmountExcGst,
					gstRate: response.data.gstRate,
					gstAmount: response.data.gstAmount,
				}}
				isOrderItemVisible={false}
			/>
		</PaymentSummarySection>
	)
};
